export default "__VITE_PUBLIC_ASSET__f729c4d1__"